
import { BaseMessage } from './base-message';

export class Exception extends BaseMessage {
    override get type(): string {
        return 'exception';
    }
}
